var _style, _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconFelicitaciones = function SvgIconFelicitaciones(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 132.7 150.5",
    style: {
      enableBackground: "new 0 0 132.7 150.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6B81C;}\n\t.st1{opacity:0.1;}\n\t.st2{fill:#FDB926;}\n")), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_felicitaciones")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_0-Plataforma-web-capacitacion-preguntas",
    transform: "translate(-885.000000, -494.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(832.000000, 398.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_felicitaciones",
    transform: "translate(55.034487, 97.457460)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,131.7c-7.9,0-15.9-1.5-23.2-4.5C28,124,21,119.2,15.1,113.1c-3.7-3.9-6.9-8.2-9.5-12.9 c-3.9-7.1-6.4-14.8-7.2-22.9C-2.3,71.2-2.1,65-0.9,59c1.2-5.9,3.2-11.7,6-17c3-5.6,6.9-10.7,11.5-15.2 c3.7-3.6,7.8-6.6,12.2-9.2c4.9-2.8,10.1-4.9,15.6-6.2c4.8-1.2,9.7-1.8,14.6-1.8c0,0,0,0,0.1,0c6.3,0,12.6,1,18.6,2.9 c4.9,1.6,9.6,3.7,13.9,6.4c4.2,2.6,8,5.7,11.4,9.3c2.4,2.4,4.5,5.1,6.4,7.8c3.1,4.5,5.6,9.5,7.4,14.6 c1.8,5.1,2.8,10.5,3.2,15.9c0.4,6.2-0.1,12.4-1.6,18.4c-1.5,6.1-3.8,11.8-7,17.1c-1.5,2.5-3.2,4.8-5,7.1 c-0.4,0.5-1.2,0.6-1.8,0.2c-0.5-0.4-0.6-1.2-0.2-1.8c1.8-2.1,3.4-4.4,4.8-6.8c3.1-5.1,5.3-10.6,6.7-16.4 c1.4-5.8,1.9-11.7,1.5-17.7c-0.3-5.2-1.4-10.3-3.1-15.2c-1.7-5-4.1-9.7-7.1-14c-1.8-2.6-3.9-5.2-6.1-7.5c-3.3-3.4-7-6.4-11-8.9 c-4.2-2.6-8.6-4.7-13.3-6.2c-5.8-1.8-11.7-2.8-17.8-2.8c0,0,0,0-0.1,0c-4.7,0-9.4,0.6-14,1.7c-5.2,1.3-10.3,3.3-14.9,6 c-4.2,2.4-8.2,5.4-11.7,8.8c-4.4,4.3-8.1,9.2-11,14.6c-2.7,5.1-4.7,10.6-5.8,16.3c-1.1,5.8-1.4,11.7-0.7,17.6 C1.6,84.8,4,92.2,7.7,99c2.5,4.5,5.6,8.6,9.1,12.3c5.7,5.9,12.4,10.4,19.9,13.5c8.7,3.6,18.4,5,27.8,4.1 c8.1-0.8,15.7-3.1,22.8-7.1c0.6-0.3,1.4-0.1,1.7,0.5c0.3,0.6,0.1,1.4-0.5,1.7c-7.4,4.1-15.4,6.6-23.8,7.4 C62.9,131.6,60.9,131.7,59,131.7z M92.5,121.7c-0.4,0-0.8-0.2-1.1-0.6c-0.4-0.6-0.2-1.4,0.4-1.7c3.2-2.1,6.6-5,9.1-7.7 c0.5-0.5,1.2-0.6,1.8-0.1c0.5,0.5,0.6,1.2,0.1,1.8c-2.6,2.9-6.1,5.9-9.6,8.2C92.9,121.6,92.7,121.7,92.5,121.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bling",
    transform: "translate(129.965513, 14.542540)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-12.9-6c-0.7,0-1.2-0.6-1.2-1.2v-7.5c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2v7.5 C-11.7-6.6-12.2-6-12.9-6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-12.9,11.5c-0.7,0-1.2-0.6-1.2-1.2V2.8c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2v7.5 C-11.7,10.9-12.2,11.5-12.9,11.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17.9-1h-7.4c-0.7,0-1.2-0.6-1.2-1.3s0.6-1.2,1.2-1.2h7.4c0.7,0,1.2,0.6,1.2,1.2S-17.2-1-17.9-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_3_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-0.5-1H-8c-0.7,0-1.2-0.6-1.2-1.3S-8.7-3.5-8-3.5h7.4c0.7,0,1.2,0.6,1.2,1.2S0.1-1-0.5-1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bling_1_",
    transform: "translate(28.965513, 142.542540)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_4_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-15.4-8.5c-0.7,0-1.2-0.6-1.2-1.2v-5c0-0.7,0.6-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2v5 C-14.2-9.1-14.7-8.5-15.4-8.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_5_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-15.4,6.5c-0.7,0-1.2-0.6-1.2-1.2v-5c0-0.7,0.6-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2v5 C-14.2,5.9-14.7,6.5-15.4,6.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_6_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-20.4-3.5h-4.9c-0.7,0-1.2-0.6-1.2-1.2S-26-6-25.3-6h4.9c0.7,0,1.2,0.6,1.2,1.2S-19.7-3.5-20.4-3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_7_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-5.5-3.5h-4.9c-0.7,0-1.2-0.6-1.2-1.2S-11.2-6-10.5-6h4.9c0.7,0,1.2,0.6,1.2,1.2S-4.9-3.5-5.5-3.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5,69.8c-1.8-1.6-4.6-1.5-6.3,0.3c-1.6,1.8-1.5,4.6,0.3,6.2l20.8,18.9c2.5,2.3,6.4,2.1,8.8-0.4 c0.1-0.1,0.1-0.1,0.2-0.2L89,59c1.6-1.9,1.3-4.6-0.6-6.2c-1.9-1.6-4.7-1.3-6.2,0.6l-28,33.4L35.5,69.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.5,98c-1.8,0-3.6-0.6-5-1.9L28.6,77.2c-1.1-1-1.8-2.4-1.8-3.9c-0.1-1.5,0.5-3,1.5-4.1 c2.1-2.3,5.7-2.5,8-0.4L54.1,85l27.1-32.4c2-2.4,5.6-2.7,8-0.7c1.2,1,1.9,2.3,2,3.8c0.1,1.5-0.3,3-1.3,4.1L60,95.6 C58.5,97.2,56.5,98,54.5,98z M32.5,69.9c-0.9,0-1.7,0.3-2.4,1c-0.6,0.6-0.9,1.4-0.8,2.3c0,0.8,0.4,1.6,1,2.2l20.8,18.9 c2,1.8,5.2,1.7,7-0.3l0.2-0.2l29.7-35.6c0.5-0.6,0.8-1.5,0.7-2.3c-0.1-0.8-0.5-1.6-1.1-2.1c-1.4-1.1-3.4-0.9-4.5,0.4 L54.4,88.6L34.6,70.7C34,70.1,33.2,69.9,32.5,69.9z"
  })))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFelicitaciones, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_felicitaciones.c1234cf1.svg";
export { ForwardRef as ReactComponent };